import styled from "styled-components";
import { flexbox, margin } from 'styled-system'


export const ButtonsContainer = styled.div`
display: flex;
margin-top: auto;
${flexbox}
${margin}
`;